<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden hidden sm:block"
    [appearance]="'compact'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.compact"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->

        <div class="mb-4 mt-3 flex h-20 items-center justify-center">
            <img class="rounded-md w-12 p-1 bg-primary" src="images/logo/logo-dark.svg" alt="Logo image" />

        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationFooter>
        <!-- User -->

        <div class="flex w-full items-center border-t px-6 py-4 justify-center ">

            <user [avatarSize]="'medium'"></user>
            <!-- <div class="ml-4 flex w-full flex-col overflow-hidden">
                <div
                    class="w-full overflow-hidden text-ellipsis whitespace-nowrap leading-normal text-current opacity-80"
                >
                    {{ user.name }}
                </div>
                <div
                    class="mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm leading-normal text-current opacity-50"
                >
                    brian.hughes&#64;company.com
                </div>
            </div> -->
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Mobile Bottom Navigation -->
<nav class="fixed bottom-3 left-3 right-3 z-90 sm:hidden print:hidden bg-gray-900 rounded-xl h-18 flex items-center justify-around px-2">
    <a routerLink="/dashboard" routerLinkActive="active-mobile-link" class="mobile-nav-item">
        <mat-icon [svgIcon]="'feather:home'" class="mobile-nav-icon"></mat-icon>
        <span class="mobile-nav-label">Dashboard</span>
    </a>
    <a routerLink="/calendar" routerLinkActive="active-mobile-link" class="mobile-nav-item">
        <mat-icon [svgIcon]="'feather:calendar'" class="mobile-nav-icon"></mat-icon>
        <span class="mobile-nav-label">Calendar</span>
    </a>
    <a routerLink="/aircraft" routerLinkActive="active-mobile-link" class="mobile-nav-item">
        <mat-icon [svgIcon]="'mat_outline:local_airport'" class="mobile-nav-icon"></mat-icon>
        <span class="mobile-nav-label">Aircraft</span>
    </a>
    <a routerLink="/people" routerLinkActive="active-mobile-link" class="mobile-nav-item">
        <mat-icon [svgIcon]="'feather:users'" class="mobile-nav-icon"></mat-icon>
        <span class="mobile-nav-label">People</span>
    </a>
    <button (click)="toggleMobileMenu()" class="mobile-nav-item" [class.text-white]="mobileMenuOpen()">
        <mat-icon class="mobile-nav-icon">{{ mobileMenuOpen() ? 'close' : 'more_horiz' }}</mat-icon>
        <span class="mobile-nav-label">{{ mobileMenuOpen() ? 'Close' : 'More' }}</span>
    </button>
</nav>

<!-- Mobile More Menu Overlay -->
@if (mobileMenuOpen()) {
    <div class="fixed inset-0 z-80 sm:hidden flex flex-col justify-end" (click)="mobileMenuOpen.set(false)">
        <div class="absolute inset-0 bg-black/50"></div>
        <div class="relative bg-white dark:bg-gray-800 rounded-t-2xl pb-24 pt-6 px-4" (click)="$event.stopPropagation()">
            <div class="flex justify-between items-center mb-6 px-2">
                <span class="text-lg font-semibold">Menu</span>
                <button (click)="mobileMenuOpen.set(false)">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="grid grid-cols-3 gap-4">
                @for (item of allMobileNavItems; track item.id) {
                    <button
                        (click)="navigateMobile(item.link)"
                        [class.altura-nav-locked]="item.locked"
                        [class.opacity-50]="item.locked"
                        class="flex flex-col items-center justify-center gap-2 p-4 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <span class="fuse-vertical-navigation-item-icon relative">
                            <mat-icon [svgIcon]="item.icon" class="!w-7 !h-7 text-gray-600 dark:text-gray-300"></mat-icon>
                        </span>
                        <span class="text-xs font-medium text-gray-700 dark:text-gray-300">{{ item.title }}</span>
                    </button>
                }
            </div>
        </div>
    </div>
}


<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header Mobile -->
    <div class="z-10 sticky top-0 dark bg-gray-900 print:hidden flex items-center justify-between h-16 px-4 md:hidden">
        <div class="flex items-center lg:mr-8 gap-4">
            <!-- Navigation toggle button -->
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')" class="hidden sm:block ">
                <mat-icon [svgIcon]="'heroicons_outline:bars-2'"></mat-icon>
            </button>
            <div class="flex">
                <img src="images/logo/logo-text-sm-on-dark.svg" class="hidden w-36 dark:flex">
            </div>
        </div>
        <!-- User -->
        <user [avatarSize]="'small'"></user>

    </div>
    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <div class="hidden bg-card sticky bottom-0-0 z-49  h-16 w-full flex-0 items-center px-4 md:px-6 print:hidden border-t-2">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">

            <div class="flex flex-row justify-end gap-3">
                <!-- Dark -->
                <div
                    class="bg-hover flex cursor-pointer items-center rounded-full p-1 ring-inset ring-primary"
                    [class.ring-2]="config.scheme === 'dark'"
                    (click)="setScheme('dark')"
                >
                    <div class="flex items-center overflow-hidden rounded-full">
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:moon'"
                        ></mat-icon>
                    </div>
                </div>
                <!-- Light -->
                <div
                    class="bg-hover flex cursor-pointer items-center rounded-full p-1 ring-inset ring-primary"
                    [class.ring-2]="config.scheme === 'light'"
                    (click)="setScheme('light')"
                >
                    <div class="flex items-center overflow-hidden rounded-full">
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:sun'"
                        ></mat-icon>
                    </div>
                </div>
            </div>

            <languages></languages>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>
            <messages></messages>
            <notifications></notifications>
            <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                ></mat-icon>
            </button>
            <user></user> -->
        </div>
    </div>
    <!-- <div
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden"
    >
        <span class="text-secondary font-medium"
            >Altura &copy; {{ currentYear }}</span
        >
    </div> -->
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->

<!-- Altura Assistant Chat Widget -->
@if (webchatEnabled()) {
    <chat-widget />
}
